import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";
import InfoGenesis from "../../../assets/img/Featured/tablet-info-genesis.png";
import IGOnDemand from "../../../assets/img/Featured/app-ondemand-food.png";
import IGQuickPay from "../../../assets/img/Featured/app-qr-quickpay-tall.png";
import Reserve from "../../../assets/img/Featured/app-reservations.png";

const CommonAreasPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return (
      <div className="page commonAreasPage">
        <Header />
        <div className="page-header">Residential Building</div>
        <div className="text-wrapper">
          <div className="top">
            <div className="topic-header">Common Areas</div>
            <HorizontalLine />
          </div>
          <div className="std-text">
            Provide residents with the ability to pick up their food and
            beverage orders at various outlets on property or get them delivered
            directly to their units.{'\n\n'}

            If they choose to dine at one of the restaurants, 
            they can pay via a QR code on the check or charge it
            directly to their account.{'\n\n'}

            Allow residents to see availability across all outlets and 
            leverage multiple seat layouts for specified
            dates.
          </div>
        </div>
        <FeaturedSolutions>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Residential Building - Common Areas", "InfoGenesis");
              addFlow("InfoGenesis");
              navigate("/solutions/info-genesis");
            }}
          >
            <div className="item-head">
              <LogoMini />
              InfoGenesis
            </div>
            <img src={InfoGenesis} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Residential Building - Common Areas", "IG OnDemand");
              addFlow("IG OnDemand");
              navigate("/solutions/ig-on-demand");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG OnDemand
            </div>
            <img src={IGOnDemand} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Residential Building - Common Areas", "IG Quick Pay");
              addFlow("IG Quick Pay");
              navigate("/solutions/ig-quick-pay");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG Quick Pay
            </div>
            <img src={IGQuickPay} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Residential Building - Common Areas", "Reserve");
              addFlow("Reserve");
              navigate("/solutions/reserve");
            }}
          >
            <div className="item-head">
              <LogoMini />
              Reserve
            </div>
            <img src={Reserve} alt="" />
          </div>
        </FeaturedSolutions>
      </div>
    );
}
export default CommonAreasPage;